import { CardHeadingGroup, CardNav } from '@storeblocks/card';
import { type FC } from 'react';

import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { CardColumn, Row } from '@/components/Grid';
import { InternalLink } from '@/components/InternalLink';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

export const TradingLinks: FC = () => {
  const organizationCmId = useOrganizationCmId();
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <Row>
      <CardColumn $span={6}>
        <CardNav
          icon="shopping_cart"
          data-test="subscription-order-link"
          orientation="horizontal"
        >
          {(ref: React.Ref<HTMLAnchorElement>) => (
            <CardHeadingGroup
              ref={ref}
              heading={texts.dashboard.tradingLinks.buyFund}
              as={InternalLink}
              to={`/${organizationCmId}/trading/subscription`}
              data-trackid={getTrackId(
                'go-to-subscription',
                TrackingElement.Link,
              )}
            />
          )}
        </CardNav>
      </CardColumn>
      <CardColumn $span={6}>
        <CardNav
          icon="hand_coins"
          data-test="redemption-order-link"
          orientation="horizontal"
        >
          {(ref: React.Ref<HTMLAnchorElement>) => (
            <CardHeadingGroup
              ref={ref}
              heading={texts.dashboard.tradingLinks.sellFund}
              as={InternalLink}
              to={`/${organizationCmId}/trading/redemption`}
              data-trackid={getTrackId(
                'go-to-redemption',
                TrackingElement.Link,
              )}
            />
          )}
        </CardNav>
      </CardColumn>
      <CardColumn $span={6}>
        <CardNav
          icon="synchronize"
          data-test="switch-order-link"
          orientation="horizontal"
        >
          {(ref: React.Ref<HTMLAnchorElement>) => (
            <CardHeadingGroup
              ref={ref}
              heading={texts.dashboard.tradingLinks.switchFund}
              as={InternalLink}
              to={`/${organizationCmId}/trading/switch`}
              data-trackid={getTrackId('go-to-switch', TrackingElement.Link)}
            />
          )}
        </CardNav>
      </CardColumn>
      <CardColumn $span={6}>
        <CardNav
          icon="menu"
          data-test="pending-order-link"
          orientation="horizontal"
        >
          {(ref: React.Ref<HTMLAnchorElement>) => (
            <CardHeadingGroup
              ref={ref}
              heading={texts.dashboard.tradingLinks.pendingOrders}
              as={InternalLink}
              to={`/${organizationCmId}/trading/orders`}
              data-trackid={getTrackId(
                'go-to-pending-order',
                TrackingElement.Link,
              )}
            />
          )}
        </CardNav>
      </CardColumn>
    </Row>
  );
};
